import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface BlogPostCardProps {
  title: string;
  slug: string;
  date: string;
  author: string;
  excerpt: string;
  image?: string;
  className?: string;
}

const BlogPostCard = ({
  title,
  slug,
  date,
  author,
  excerpt,
  image,
  className
}: BlogPostCardProps) => {
  return (
    <Card className={cn("mb-6 overflow-hidden hover:shadow-lg transition-shadow", className)}>
      {image && (
        <Link to={`/blog/${slug}`} aria-label={`Read ${title}`}>
          <img
            src={image}
            alt=""
            width={1600}
            height={1000}
            loading="lazy"
            className="aspect-[8/5] w-full object-cover"
          />
        </Link>
      )}
      <CardHeader>
        <div className="flex justify-between items-start mb-2">
          <CardTitle className="text-xl md:text-2xl font-semibold">
            <Link 
              to={`/blog/${slug}`}
              className="text-[#6B4EE6] hover:text-[#5a3fd4] transition-colors"
            >
              {title}
            </Link>
          </CardTitle>
          <span className="text-sm text-gray-500 whitespace-nowrap ml-4">{date}</span>
        </div>
      </CardHeader>
      <CardContent>
        <p className="text-gray-700 mb-4 line-clamp-3">{excerpt}</p>
        <div className="flex justify-between items-center">
          <span className="text-sm text-gray-600 italic">By {author}</span>
          <Link 
            to={`/blog/${slug}`}
            className="text-[#6B4EE6] hover:text-[#5a3fd4] text-sm font-medium transition-colors"
          >
            Read more →
          </Link>
        </div>
      </CardContent>
    </Card>
  );
};

export default BlogPostCard;